export const FETCH_SAMPLE_ACCEPTED_REQUEST =
  "FETCH_SAMPLE_ACCEPTED_REQUEST";
export const FETCH_SAMPLE_ACCEPTED_SUCCESS =
  "FETCH_SAMPLE_ACCEPTED_SUCCESS";
export const FETCH_SAMPLE_ACCEPTED_FAILURE =
  "FETCH_SAMPLE_ACCEPTED_FAILURE";
